import {Injectable} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

@Injectable({providedIn: 'root'})
export class LeadFormContractDetailsValidationService {

  /**
   * Validation pattern to check whether the provided string represents a number with 2 decimals at max.
   *
   * @public used there in contract validation service.
   */
  private static getNumber2DecimalsRegex() {
    return /^[0-9]+([.,][0-9]{1,2})?$/;
  }

  /**
   * Validate the dates from the date pickers inside the form group so that
   * the date in the start date picker is not later then the date in the end date picker.
   */
  public createDatesRangeValidatorFn(): ValidatorFn {
    return (fg: UntypedFormGroup) => {
      const start = fg.get('rangeStart').value;
      const end = fg.get('rangeEnd').value;
      return (!start || !end) ? {range: false} :
        (new Date(start.year, start.month - 1, start.day).getTime() < new Date(end.year, end.month - 1, end.day).getTime()) ? null :
          {range: true};
    };
  }

  /**
   * Creates a validation function to check whether the input value is a number with 2 decimals at max.
   */
  createNumber2DecimalsValidator(): ValidationErrors {
    return (ctrl: UntypedFormControl) => {
      if (ctrl.value) {
        const value: string = ctrl.value;
        return LeadFormContractDetailsValidationService.getNumber2DecimalsRegex().test(value) ?
          null :
          {numberFormat: true};
      }
      return null;
    };
  }
}
